"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCountryToRouteGeographyFlag = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformCountryToRouteGeographyFlag = (countryIsoCode) => {
    if (!countryIsoCode) {
        return undefined;
    }
    const isoCodeInLowerCase = countryIsoCode.toLowerCase();
    if (legacy_config_1.ASIA_COUNTRIES_ISO_CODES.includes(isoCodeInLowerCase)) {
        return legacy_enums_1.RouteGeographyFlag.isAsian;
    }
    if (["us", "au", "nz"].includes(isoCodeInLowerCase)) {
        return legacy_enums_1.RouteGeographyFlag.isEnglishSpeaking;
    }
    if (isoCodeInLowerCase === "mx") {
        return legacy_enums_1.RouteGeographyFlag.isMexican;
    }
    if (isoCodeInLowerCase === "cu") {
        return legacy_enums_1.RouteGeographyFlag.isCuba;
    }
    if (isoCodeInLowerCase === "bs") {
        return legacy_enums_1.RouteGeographyFlag.isBahamas;
    }
    // Argentina, Bolivia, Chile, Colombia, Costa Rica, Algieria, Ecuador, Guatemala, Morocco, Panama, Peru
    if (legacy_config_1.SUV_REPLACING_SEDAN_COUNTRIES_ISO_CODES.includes(isoCodeInLowerCase)) {
        return legacy_enums_1.RouteGeographyFlag.isSuvReplacingLuxurySedan;
    }
    return undefined;
};
exports.transformCountryToRouteGeographyFlag = transformCountryToRouteGeographyFlag;
//# sourceMappingURL=transformCountryToRouteGeographyFlag.js.map